import { AnalysisResult } from '@/gen/controls/v1/analysis_result_pb'

import { formatTimestamp } from '@/lib/date/date'

import { RISK_QUESTIONNAIRE_THREAD_LABELS } from '@/pages/control/labels'
import { StatusChangeBadges } from '@/pages/control/risk-questionnaire-thread-card/status-change-badges'
import type { StatusChange } from '@/pages/control/risk-questionnaire-thread-card/types'
import { citedArtifactNames } from '@/pages/control/risk-questionnaire-thread-card/utils'

type EarlierEvaluationProps = {
  evaluation: AnalysisResult
  change?: StatusChange
}

export const EarlierEvaluation = ({ evaluation, change }: EarlierEvaluationProps) => {
  const artifactNames = citedArtifactNames(evaluation.quotes)

  return (
    <li className='flex flex-col gap-1'>
      <div className='flex flex-col gap-2'>
        <span className='text-main-foreground-primary text-label-default'>
          {formatTimestamp(evaluation.createdAt, 'dateTime')}
        </span>
        {change && <StatusChangeBadges change={change} />}
      </div>
      <p className='text-main-foreground-tertiary text-body-default'>{evaluation.summary}</p>
      {artifactNames.length > 0 && (
        <p className='text-main-foreground-tertiary text-body-small'>
          {RISK_QUESTIONNAIRE_THREAD_LABELS.EARLIER_EVALUATION_EVIDENCE(artifactNames)}
        </p>
      )}
    </li>
  )
}
